import React, { useMemo } from "react";

import { ErrorIcon, RemoveIcon, Tick } from "@/v1/components/atoms/Icons";
import { Spinner } from "@/v1/components/atoms/Spinner/Spinner";

import { IAsset } from "../../../../../../v1/components/pages/GameDetail/components/AssetsTab/types/Asset.interface";
import { AssetStatus } from "../../../../../../v1/components/pages/GameDetail/components/AssetsTab/utils/constants";
import { useRequestsStore } from "../../../../../store/useRequestsStore/useRequestsStore";

import "./assetStatusIcon.scss";

export const AssetStatusIcon: React.FC<IAsset> = currentAsset => {
  const removeAsset = useRequestsStore(state => state.removeAsset);

  const statusIcon = useMemo(() => {
    const assetStatusIcons = {
      [AssetStatus.ERROR]: <ErrorIcon />,
      [AssetStatus.IN_PROGRESS]: <Spinner />,
      [AssetStatus.SUCCESS]: <Tick />,
      [AssetStatus.WAITING]: <Spinner />,
    };

    return assetStatusIcons[currentAsset.status];
  }, [currentAsset.status]);

  return (
    <div className="asset-status-icon">
      <button
        className="reset-btn asset-status-icon__remove"
        onClick={() => removeAsset(currentAsset)}
      >
        <RemoveIcon />
      </button>
      <div className="asset-status-icon__icon">{statusIcon}</div>
    </div>
  );
};
